import { i18n } from '@lingui/core';
import { en, es } from 'make-plural/plurals';

export const locales = {
  en: 'English',
  es: 'Spanish',
};
export const defaultLocale = 'en';

i18n.loadLocaleData({
  en: { plurals: en },
  es: { plurals: es },
});

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export async function dynamicActivate(locale: string) {
  const { messages } = await require(`./locales/${locale}/messages.js`);
  i18n.load(locale, messages);
  i18n.activate(locale);
}
